module.exports = __webpack_public_path__ + "static/media/uki.48e2664a.jpg";